<div
  #wrapper
  class="wrapper"
  [ngClass]="{
    'nav-collapsed': isCollapsed,
    'menu-collapsed': isCollapsed,
    'sidebar-sm': isSidebar_sm,
    'sidebar-lg': isSidebar_lg
  }"
  [dir]="options.direction"
>
  <div
    *ngIf="userType === 'USER'"
    #appSidebar
    appSidebar
    class="app-sidebar"
    (toggleHideSidebar)="toggleHideSidebar($event)"
    [ngClass]="{ 'hide-sidebar': hideSidebar }"
    data-active-color="white"
  >
    <app-sidebar></app-sidebar>
    <div class="sidebar-background" #sidebarBgImage></div>
  </div>
  <app-navbar (toggleHideSidebar)="toggleHideSidebar($event)"></app-navbar>
  <div class="main-panel">
    <div class="main-content">
      <div class="content-wrapper">
        <div class="container-fluid">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
